module.exports = __webpack_public_path__ + "img/altair-alpha.d2251d22.png";